import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const TeamForm = withSafeSuspense(
  lazy(
    async () => ({ default: (await import('./team_form')).TeamForm })
  )
)
